import React from "react";
import cx from "classnames";
import { FieldError } from "react-hook-form";

interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string | FieldError | undefined;
}

const TextInput: React.FC<TextInputProps> = React.forwardRef<
  HTMLInputElement,
  Omit<TextInputProps, "ref">
>(({ error, className, name, ...rest }, ref) => {
  const errorId = error && name ? `${name}-error` : undefined;
  const describedBy =
    [rest["aria-describedby"], errorId].filter(Boolean).join(" ") || undefined;

  return (
    <div className="form-control w-full">
      <input
        className={cx(
          "appearance-none block w-full text-gray-700 border rounded py-2 px-4 leading-tight focus:outline-primary",
          className,
          {
            "border-red-500 outline-red-500 focus:border-red-500 focus:outline-red-500":
              !!error,
          },
        )}
        ref={ref}
        name={name}
        id={name}
        {...rest}
        aria-invalid={error ? true : rest["aria-invalid"]}
        aria-describedby={describedBy}
      />

      {error && (
        <p id={errorId} className="text-red-500 text-xs mt-1">
          {typeof error === "string" ? error : error?.message}
        </p>
      )}
    </div>
  );
});

export default TextInput;
